import { takeEvery } from 'redux-saga/effects';

import * as listYourCarActions from 'store/modules/listYourCar';
import { listYourCar } from './utils';

export default function* listenCreateBasket() {
  yield takeEvery(listYourCarActions.listYourCar.toString(), listYourCar);
}
